import { initialState } from './initial-state';
import {
    initialize as initReducer,
    receiveSearchResults as receiveSearchResultsReducerAction,
} from './reducer';
import { wishlistAddRange } from 'tradera/state/items/reducer';

/**
 *
 * @param {object} payload the normalized version of the response
 * @param {string} payload.endpoint
 * @param {object} payload.queryParams
 * @param {object} payload.result
 * @param {object} [?payload.result.categoryPath]
 * @param {object[]} [payload.result.items]
 * @param {object} [payload.result.itemsOnDisplay]
 * @param {object[]} [payload.result.itemsOnDisplay.items]
 */
export const receiveSearchResults =
    (payload, shippingRegionCountryCodeIso2) => (dispatch) => {
        dispatch(
            receiveSearchResultsReducerAction({
                ...payload,
                shippingRegionCountryCodeIso2,
            }),
        );
        const items = payload.result?.items || [];
        dispatch(
            wishlistAddRange(
                items
                    .filter((item) => item.inWishList)
                    .map((item) => item.itemId),
            ),
        );
    };

export const initialize = () => (dispatch) => {
    dispatch(initReducer(initialState));
};
